var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScheduledCampaignsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_979_3328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.4733 10.1949L39.7081 0.429102C39.4334 0.154297 39.0607 0 38.6723 0H16.2109C13.7878 0 11.8164 1.97139 11.8164 4.39453V23.7146C5.23379 24.4457 0.0976562 30.0421 0.0976562 36.8164C0.0976562 44.0858 6.01182 50 13.2812 50H45.5078C47.931 50 49.9023 48.0286 49.9023 45.6055V11.2308C49.9023 10.8422 49.748 10.4697 49.4733 10.1949ZM40.1367 5.00127L44.901 9.76562H40.1367V5.00127ZM3.02734 36.8164C3.02734 31.1624 7.62725 26.5625 13.2812 26.5625C18.9353 26.5625 23.5352 31.1624 23.5352 36.8164C23.5352 42.4704 18.9353 47.0703 13.2812 47.0703C7.62725 47.0703 3.02734 42.4704 3.02734 36.8164ZM45.5078 47.0703H21.5575C24.1906 44.9409 25.99 41.8204 26.3831 38.2812H41.6016C42.4105 38.2812 43.0664 37.6254 43.0664 36.8164C43.0664 36.0074 42.4105 35.3516 41.6016 35.3516H26.383C26.1441 33.2012 25.3865 31.2052 24.2377 29.4922H41.6016C42.4105 29.4922 43.0664 28.8363 43.0664 28.0273C43.0664 27.2184 42.4105 26.5625 41.6016 26.5625H21.5575C19.6512 25.0209 17.3084 23.9992 14.7461 23.7146V4.39453C14.7461 3.58682 15.4032 2.92969 16.2109 2.92969H37.207V11.2305C37.207 12.0395 37.8629 12.6953 38.6719 12.6953H46.9727V45.6055C46.9727 46.4132 46.3155 47.0703 45.5078 47.0703Z",
    fill: "#C834A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6016 17.7734H20.1172C19.3082 17.7734 18.6523 18.4293 18.6523 19.2383C18.6523 20.0473 19.3082 20.7031 20.1172 20.7031H41.6016C42.4105 20.7031 43.0664 20.0473 43.0664 19.2383C43.0664 18.4293 42.4105 17.7734 41.6016 17.7734Z",
    fill: "#C834A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1875 38.2812C17.9965 38.2812 18.6523 37.6254 18.6523 36.8164C18.6523 36.0074 17.9965 35.3516 17.1875 35.3516H14.7461V30.957C14.7461 30.148 14.0902 29.4922 13.2812 29.4922C12.4723 29.4922 11.8164 30.148 11.8164 30.957V36.8164C11.8164 37.6254 12.4723 38.2812 13.2812 38.2812H17.1875Z",
    fill: "#C834A6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_979_3328"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduledCampaignsIcon);
export default __webpack_public_path__ + "static/media/scheduled-campaigns-icon.f862cf5d4fedb238f014743c8ec5bd86.svg";
export { ForwardRef as ReactComponent };